/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useState } from 'react'
import { Badge, Tabs } from 'antd-mobile'
import * as _ from 'lodash'
import useRootStore from '@store/useRootStore'
// css
import { BadgeStyle, TabTxt, TotalTabWrap } from '@styles/base.style'
import { Models } from 'rmc-tabs/lib/Models'
import { useOnMount } from '@utils/reactExt'
import { BETTING_HISTORY_TAB_KEY } from '@constants/index'
import { observer } from 'mobx-react'
import { Button } from '@styles/button.style'
import { keepBetListBtnStyle } from '@views/BettingHistory/BettingHistoryList/index.style'
import BettingHistoryList from '../BettingHistoryList'
import { GlobalStoreKey } from '@v2/constants/common'
import { PAGE_TYPE } from '@interface/common'
import { AdvButton } from '@components/Button'
import { UserPickBannerStyle } from '../BettingHistoryListItem/index.style'
// img
import ChampBannerImg from '@assets/images/banner/champ-banner-betting-history.jpg'
import ChampBannerDetailImg from '@assets/images/banner/champ-banner-detail.jpg'
import KeepListIco from '@assets/images/icon/betting_history_icon/keep-list.png'
import PopupUtils from '@utils/popup-utils'


interface BettingHistoryTabProps {
  isFullModal?: boolean // fullModal 일 경우 full-modal className 을 붙여 주기 위해...
  pageType?: PAGE_TYPE
}

// 베팅 내역 탭 이하 대부분이 탭 인덱스를 기준으로 분기되고 있음.
// 신규 탭 추가시 인덱스를 기준으로 동작하는 코드는 동작하지 않으므로 리펙토링 필요.
const BettingHistoryTab: React.FC<BettingHistoryTabProps> = (props: BettingHistoryTabProps) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [currentTabKey, setCurrentTabKey] = useState(BETTING_HISTORY_TAB_KEY.ONGOING)
  const { globalStore, bettingHistoryStore, logStore } = useRootStore()
  const { deleteBetActive } = bettingHistoryStore
  const { showBettingListItemSelectBtn } = globalStore
  const { isFullModal, pageType } = props

  const [bettingHistoryInitState, setBettingHistoryInitState] = useState<{ [key: string]: any }>()

  if (_.isNil(bettingHistoryInitState)) {
    const { onlyMajorClub, fromViewType } = bettingHistoryStore?.bettingHistoryInitProps ?? {}
    setBettingHistoryInitState({ onlyMajorClub, fromViewType })
  }

  const bettingHistoryShareEnable = _.toString(globalStore.findGlobalSetting(GlobalStoreKey.BETTING_HISTORY_SHARE_ENABLED)?.value ?? 0) === '1'
  const betCount = bettingHistoryInitState?.onlyMajorClub ?
    bettingHistoryStore.onGoingBetCountByOnlyMajorClub : bettingHistoryStore.onGoingBetCount

  const badgeClassName = betCount > 0 ?
    'tab-badge bet-history-tab' :
    'tab-badge bet-history-tab inactive'

  const fromUserPick = () => {
    return pageType === PAGE_TYPE.USER_PICK || pageType === PAGE_TYPE.USER_PICK_DETAIL
      || pageType === PAGE_TYPE.MATCHUP_DETAIL_PICK
  }

  let whiteMiniTabWrapClassName: string
  if (deleteBetActive && !showBettingListItemSelectBtn) {
    whiteMiniTabWrapClassName = 'betting-history-tab betting-share disabled'
  } else if (bettingHistoryShareEnable && !fromUserPick()) {
    whiteMiniTabWrapClassName = 'betting-history-tab betting-share'
  } else if (fromUserPick()) {
    whiteMiniTabWrapClassName = 'betting-history-tab user-pick'
  } else {
    whiteMiniTabWrapClassName = 'betting-history-tab'
  }
  // 4번째 탭은 강제로 너비 0으로 설정 (보관 탭)
  const bettingHistoryTabs = [
    {
      title:
        <Fragment>
          <TabTxt>진행중</TabTxt>
          <Badge
            text={betCount.toString()}
            overflowCount={99}
            css={BadgeStyle}
            className={badgeClassName} /* 0개일 경우 'inactive' className 추가 */
          />
        </Fragment>
      , key: BETTING_HISTORY_TAB_KEY.ONGOING,
    },
    { title: <TabTxt>마감</TabTxt>, key: BETTING_HISTORY_TAB_KEY.CLOSED },
    { title: <TabTxt>저장</TabTxt>, key: BETTING_HISTORY_TAB_KEY.SHARED },
    {
      title: <Button css={keepBetListBtnStyle} className="keep-btn disabled">
        <span className="keep-btn-bg"/>
        <img src={KeepListIco} alt="보관내역" className="keep-ico"/>
      </Button>, key: BETTING_HISTORY_TAB_KEY.SAVED,
    },
  ]

  if (!bettingHistoryShareEnable) {
    _.remove(bettingHistoryTabs, tab => {
      return tab.key === BETTING_HISTORY_TAB_KEY.SHARED
    })
  }

  if (fromUserPick()) {
    _.remove(bettingHistoryTabs, tab => {
      return tab.key === BETTING_HISTORY_TAB_KEY.SHARED || tab.key === BETTING_HISTORY_TAB_KEY.SAVED
    })
  }

  const findTabIndexByTabKey = (key: BETTING_HISTORY_TAB_KEY) => {
    return _.findIndex(bettingHistoryTabs, tab => {
      return tab.key === key
    })
  }

  useOnMount(() => {
    if (globalStore.bettingHistoryTabInitialTabKey !== BETTING_HISTORY_TAB_KEY.ONGOING) {
      setCurrentTabKey(globalStore.bettingHistoryTabInitialTabKey)
      setCurrentIndex(findTabIndexByTabKey(globalStore.bettingHistoryTabInitialTabKey))
      globalStore.setBettingHistoryTabInitialTabKey(BETTING_HISTORY_TAB_KEY.ONGOING)
    }
  })

  const tabChanged = (tab: Models.TabData, index: number) => {
    if (tab.key === BETTING_HISTORY_TAB_KEY.SAVED) {
      logStore.writeButtonLog({ pageId: 'c010', buttonId: '004' }).catch(console.error)
    }
    setCurrentTabKey(tab.key as BETTING_HISTORY_TAB_KEY)
    setCurrentIndex(index)
  }

  const tabCount = _.size(bettingHistoryTabs) > 3 ? 3 : _.size(bettingHistoryTabs)

  const banner = (
    <img src={ChampBannerImg} alt="바카라 하기 딱 좋은 날이네 챔프포커 바카라"/>
  )

  const isBanner = currentIndex === 0 && (!isFullModal || globalStore.visibleBubbleBetList)

  const onClickDetailBenefit = () => {
    PopupUtils.showManagedUserDetailPopup({ popupImgUrl: ChampBannerDetailImg })
  }

  return (
    <Fragment>
      <TotalTabWrap whiteBox className={isBanner ? whiteMiniTabWrapClassName: `${whiteMiniTabWrapClassName} no-banner`} tabCount={tabCount}>
        <Tabs tabs={bettingHistoryTabs} initialPage={currentIndex} page={currentIndex} onChange={tabChanged}/>
      </TotalTabWrap>
      {isBanner &&
        <AdvButton
          contents={banner}
          css={UserPickBannerStyle}
          onClick={onClickDetailBenefit}
        />
      }
      <BettingHistoryList pageType={pageType} isFullModal={isFullModal} currentTabKey={currentTabKey}
                          onlyMajorClub={bettingHistoryInitState?.onlyMajorClub}
                          fromViewType={bettingHistoryInitState?.fromViewType}/>
    </Fragment>
  )
}

export default observer(BettingHistoryTab)
